<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    What if I forget my account password?
                </h2>
                <p>
                    No worries. You can simply reset your account password by verifying your registered phone
                    number.</p>
                <h3>
                    If you’ve logged out
                </h3>
                <ul>
                    <li>
                        Enter the account’s registered phone number.
                    </li>
                    <li>
                        Tap <strong>Forget Password > Reset via Phone</strong>.
                    </li>
                    <ul>
                        <li>
                            Alternatively, you can log in via SMS Code without using password.
                        </li>
                    </ul>
                    <li>
                        Tap <strong>Get Verification Code</strong>. Wait for an SMS to be delivered to your phone.
                    </li>
                    <li>
                        Enter 6-digit code on the verification screen in ToTok.
                    </li>
                    <li>
                        Once it’s verified, you are able to set the new password.
                    </li>
                </ul>

                <h3>If you’ve logged in</h3>
                <ul>
                    <li>
                        Go to <strong>Me</strong> tab.
                    </li>
                    <li>
                        Tap <strong>Settings> Account > Password > Forgot Password</strong>.
                    </li>
                    <li>
                        Make sure the number filled in is the account’s registered phone number.
                    </li>
                    <li>
                        Tap <strong>Get Verification Code</strong>. Wait for an SMS to be delivered to your phone.
                    </li>
                    <li>
                        Enter 6-digit code on the verification screen in ToTok.
                    </li>
                    <li>
                        Once it’s verified, you are able to set the new password.
                    </li>
                </ul>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
